import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";


pageTitleStyles.container = {
    offsetCss: css`
    width:100% !important;
`,
}
pageTitleStyles.titleText = {
    variant: "h2",
    css: css`
        letter-spacing: 0;
        color: #33333a;
        font-weight: 600;
        margin-bottom: 0.5rem;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 26px;
                    line-height: 31px;
                    padding: 0 15px;
                `,
                css`
                    font-size: 26px;
                    line-height: 31px;
                    padding: 0 15px;
                `,
                css`
                    font-size: 26px;
                    line-height: 31px;
                `,
                css`
                    font-size: 30px;
                    line-height: 36px;
                `,
                css`
                    font-size: 30px;
                    line-height: 36px;
                `,
            ])}
    `,
};
